export let DRAWER_WIDTH: number = 260;
